import React from 'react';
import { Routes, Route } from 'react-router-dom';
import NavBar from './NavBar';
import Home from './components/Home';
import Research from './components/Research';
import Publications from './components/Publications';
import Journal from './components/Publications/Journal';
import Conference from './components/Publications/Conference';
import Book from './components/Publications/Book';
import Other from './components/Publications/Other';
import Award from './components/Publications/Award';
import Education from './components/Education';
import Admissions from './components/Admissions';
import OtherInfo from './components/OtherInfo';

function App() {
    return (
        <>
            <NavBar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/research" element={<Research />} />
                <Route path="/publications" element={<Publications />}>
                    <Route path="journal" element={<Journal />} />
                    <Route path="conference" element={<Conference />} />
                    <Route path="book" element={<Book />} />
                    <Route path="other" element={<Other />} />
                    <Route path="award" element={<Award />} />
                </Route>
                <Route path="/education" element={<Education />} />
                <Route path="/admissions" element={<Admissions />} />
                <Route path="/other-info" element={<OtherInfo />} />
            </Routes>
        </>
    );
}

export default App;
